module.exports = __webpack_public_path__ + "img/header_bg.aaae4e13.png";